import { render, staticRenderFns } from "./AnnouncementEdit.vue?vue&type=template&id=1f08f9c6&scoped=true&"
import script from "./AnnouncementEdit.vue?vue&type=script&lang=js&"
export * from "./AnnouncementEdit.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementEdit.vue?vue&type=style&index=0&id=1f08f9c6&prod&lang=scss&"
import style1 from "./AnnouncementEdit.vue?vue&type=style&index=1&id=1f08f9c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08f9c6",
  null
  
)

export default component.exports